import { QUICK_REACT_EMOJIS } from '@/config/emoji-config';

const STORAGE_KEY = 'flock_recent_emojis';
const MAX_RECENT = 10;

/**
 * The user's most recently used reaction emojis, newest first, seeded with
 * the standard quick-react set so the row is always full.
 */
export function getRecentEmojis(): string[] {
  let recent: string[] = [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) recent = JSON.parse(raw);
  } catch {
    // Ignore storage errors
  }
  const merged = [...recent];
  for (const emoji of QUICK_REACT_EMOJIS) {
    if (!merged.includes(emoji)) merged.push(emoji);
  }
  return merged.slice(0, MAX_RECENT);
}

export function pushRecentEmoji(emoji: string): void {
  try {
    const next = [emoji, ...getRecentEmojis().filter((e) => e !== emoji)].slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage errors
  }
}
